import ElevateLearningLogo from '@/assets/branding/elevate/elevate-learning-logo.png';

// NOTE: Placeholder logo used until Elevate Learning provides assets.
// Color mapping rationale:
// - brand_primary: Purple (#673AB7) as the core brand color (books/text accents)
// - brand_primary_hover: Deep Violet (#2F1C5D) as the darker hover state
// - brand_primary_highlight: Bright Aqua Glow (#33FFF5) for luminous highlights
// - brand_primary_mid: Soft Neon Purple Glow (#9C27B0) as a saturated mid variant
// - brand_primary_dark: Deep Violet (#2F1C5D) for strong headers/brand marks
// - brand_secondary: Teal (#00CFCF) as the secondary/accent (lightbulb glow)
const colors = {
  // Brand colors
  brand_primary: '#673AB7',
  brand_primary_hover: '#2F1C5D',
  brand_primary_highlight: '#33FFF5',
  brand_primary_mid: '#9C27B0',
  brand_primary_dark: '#2F1C5D',
  brand_secondary: '#00CFCF',
  brand_accent_start: '#7A4CC6',
  brand_accent_end: '#2F9EC7',
  brand_accent_light_start: '#F1ECFB',
  brand_accent_light_end: '#DFF4F8',
  brand_complementary_accent: 'rgb(156,218,45)',
  brand_auth_gradient_mid: '#00CFCF',
  brand_auth_gradient_end: '#2F1C5D',
  brand_auth_warp_mid: '#9C27B0',
};

export default {
  name: 'Elevate Learning',
  isSAML: true,
  allowPersonalCourses: false,
  logo: ElevateLearningLogo,
  colors,
};
